import React, { useState } from 'react';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/catalog/hero';
import SectionCatalog from '../../components/catalog/sections/SectionCatalog/SectionCatalog';
import Layout from '../../components/global/Layout';
import { fetcher } from '../../utils/fetcher';
import { buildCatalogURL } from '../../utils/catalogUrlBuilder';

const BukuNonTeks = () => {
  const location = useLocation();
  const [title, setTitle] = useState(location.state?.title || null);
  const [typeSearchBook, setTypeSearchBook] = useState(location.state?.typeBook || null);

  const [limit] = useState(12);
  const [typeBook, setTypeBook] = useState('type_pdf');
  const [typeCatalogue, setTypeCatalogue] = useState('getNonTextBooks');

  const [popularBook, setPopularBook] = useState('');
  const [latestBook, setLatestBook] = useState('');
  const [level, setLevel] = useState('');
  const [tag, setTag] = useState('Buku Model');

  const endpointURL = buildCatalogURL({
    typeCatalogue,
    typeBook,
    latestBook,
    popularBook,
    title,
    typeSearchBook,
    level,
    tag
  });

  const { data, isLoading } = useSWR(endpointURL, fetcher);

  const books = data?.results || [];

  const filterSearchCatalogue = (data) => {
    setTitle(data.title);
    setTypeCatalogue(data.typeCatalogue);

    if (data.typeCatalogue === 'getPenggerakTextBooks') setTypeSearchBook('Kurikulum Merdeka');
    if (data.typeCatalogue === 'getTextBooks') setTypeSearchBook('Teks K13');
    if (data.typeCatalogue === 'getNonTextBooks') setTypeSearchBook('Nonteks');
  };

  const handleFilter = (filter, type) => {
    if (type === 'level') {
      setLevel(filter === level ? '' : filter);
    }
    if (type === 'tag') {
      setTag(filter === tag ? '' : filter);
    }
  };

  return (
    <Layout>
      <Hero
        typeCatalogue={typeCatalogue}
        setTypeCatalogue={(type) => {
          setTypeCatalogue(type);
        }}
      />
      <SectionCatalog
        setPopularBook={setPopularBook}
        setLatestBook={setLatestBook}
        searchTitle={title}
        books={books}
        loading={isLoading}
        skeletonCount={limit}
        typeBook={typeBook}
        typeCatalogue={typeCatalogue}
        setSearchTypeCatalogue={filterSearchCatalogue}
        level={level}
        setLevelNonText={(filter) => handleFilter(filter, 'level')}
        tag={tag}
        setTagNonText={(filter) => handleFilter(filter, 'tag')}
      />
    </Layout>
  );
};

export default BukuNonTeks;
